import React, { useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { all } from "axios";
import { customBaseUrl, httpGet } from "../action/https";

const MerchantSearchableSelector = ({ value, handleChange, sx }) => {
  const [searchKey, setSearchKey] = React.useState(null);
  const [options, setOptions] = React.useState([]);
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    if (!searchKey) {
      setOptions([]);
      return;
    }

    const handler = setTimeout(async () => {
      let searchTerm = searchKey;
      if (!searchKey.includes("@")) {
        const digits = searchKey.replace(/\D/g, "");
        if (digits.length === 11 && digits.startsWith("0")) {
          searchTerm = "+234" + digits.substring(1);
        }
      }

      try {
        const response = await axiosPrivate.get(
          `${customBaseUrl.baseUrl}/auth-serviceV3/admin/users/email/${searchTerm}`
        );
        const resData = response?.data;
        let results = [];
        if (resData && resData.data) {
          if (Array.isArray(resData.data)) {
            results = resData.data;
          } else if (resData.data.content && Array.isArray(resData.data.content)) {
            results = resData.data.content;
          } else {
            results = [resData.data];
          }
        }
        setOptions(results);
      } catch (error) {
        console.error("merchant search error", error);
        setOptions([]);
      }
    }, 400);

    return () => {
      clearTimeout(handler);
    };
  }, [searchKey]);

  return (
    <Autocomplete
      value={value}
      onChange={handleChange}
      options={options}
      getOptionLabel={(option) => {
        if (!option) return "";
        const firstName = option.firstName || "";
        const lastName = option.lastName || option.surname || "";
        const email = option.email || "";
        const merchantId = option.merchantId || option.userId || "";
        return `${firstName} ${lastName} - ${email} - ${merchantId}`.trim();
      }}
      isOptionEqualToValue={(option, val) => 
        (option?.merchantId || option?.userId) === (val?.merchantId || val?.userId)
      }
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            onChange={(e) => setSearchKey(e.target.value)}
            label="Search User"
            variant="outlined"
          />
        );
      }}
      sx={sx}
    />
  );
};

export default MerchantSearchableSelector;
